document.addEventListener('DOMContentLoaded', function () {
	$('[data-datagrid-dialog=true]').click(function() {
		const dialogSelector = $(this).data('dialog-selector') ? $(this).data('dialog-selector') : '.datagrid-dialog';
		const modal = new bootstrap.Modal(dialogSelector)
		modal.show();
		$(dialogSelector + ' .datagrid-dialog-link').prop('href', $(this).prop('href'));
		$(dialogSelector + ' .datagrid-dialog-message').html($(this).data('datagrid-dialog-message'));
		return false;
	});
});